import React from "react";

// Print-only receipt. Rendered off-screen normally, becomes the only
// visible element under @media print (see index.css .print-only rules).
// Layout is 80mm-ish thermal-friendly (single column, monospace,
// vertical rhythm). Same DTO shape as GET /api/pos/orders/{id}/receipt.
export default function PrintableReceipt({ receipt }) {
  if (!receipt) return null;
  const fmt = (c) => `€ ${(c / 100).toFixed(2)}`;
  const co = receipt.company || {};
  const issued = receipt.issued_at ? new Date(receipt.issued_at) : null;

  return (
    <div className="print-only" data-testid="printable-receipt">
      <div className="pr-header">
        <div className="pr-brand">{co.name}</div>
        {(co.address_lines || []).map((l, i) => <div key={i}>{l}</div>)}
        {co.contact && <div>{co.contact}</div>}
      </div>

      <div className="pr-hr" />
      <div className="pr-meta">
        <div><span>Beleg-Nr</span><span>{receipt.receipt_number}</span></div>
        <div><span>Datum</span><span>{issued ? issued.toLocaleString("de-DE") : "-"}</span></div>
        <div><span>Kasse</span><span>{receipt.terminal?.name || "-"}</span></div>
        <div><span>Standort</span><span>{receipt.location?.name || "-"}</span></div>
        {receipt.customer && (
          <div><span>Kunde</span><span>{receipt.customer.name} · {receipt.customer.club_card_id}</span></div>
        )}
      </div>
      <div className="pr-hr" />

      <table className="pr-lines">
        <thead>
          <tr><th>Menge</th><th>Artikel</th><th>Preis</th><th>Summe</th></tr>
        </thead>
        <tbody>
          {receipt.lines.map((ln, i) => (
            <tr key={i}>
              <td>{ln.quantity}×</td>
              <td>
                <div>{ln.name}</div>
                {ln.ean && <div className="pr-ean">EAN {ln.ean}</div>}
              </td>
              <td>{fmt(ln.unit_price_cents)}</td>
              <td>{fmt(ln.line_gross_cents ?? ln.line_net_cents)}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="pr-hr" />
      <div className="pr-totals">
        <div><span>Zwischensumme</span><span>{fmt(receipt.subtotal_cents)}</span></div>
        <div><span>MwSt</span><span>{fmt(receipt.tax_cents)}</span></div>
        {(receipt.tax_summary || []).map((t) => (
          <div key={t.rate} className="pr-tax-row">
            <span>· {t.rate}% (netto {fmt(t.net_cents)})</span>
            <span>{fmt(t.tax_cents)}</span>
          </div>
        ))}
        <div className="pr-total"><span>Gesamt</span><span>{fmt(receipt.total_cents)}</span></div>
      </div>

      <div className="pr-hr" />
      <div className="pr-payment">
        <div><span>Zahlung</span><span>{receipt.payment?.provider || "-"} · {receipt.payment?.status || "-"}</span></div>
        {receipt.payment?.external_payment_id && (
          <div className="pr-ext"><span>Trans-ID</span><span>{receipt.payment.external_payment_id}</span></div>
        )}
      </div>

      <div className="pr-hr" />
      <div className="pr-legal">
        {co.tax_id && <div>{co.tax_id}</div>}
        {co.tax_number && <div>{co.tax_number}</div>}
        {co.legal_line && <div>{co.legal_line}</div>}
      </div>
      <div className="pr-footer">{co.footer}</div>
    </div>
  );
}
